import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import { InsetBlendTVButton } from "../buttons";
import { CheckMarkIcon } from "../icons/index.jsx";
import { handleAcctValidationErrors } from "../../controller/errorHandlers/accountValidationErrorHandler.js";
import { handlePhoneInputChange } from "../../controller/watcherAndClearFunctions/accountVerificationClearsWatchersFn.js";
import { CellPhoneIcon, SkitsOlympicLogoIcon } from "../icons/index.jsx";
import ErrorMessageModal from "../errorMessageModal/errorMessageModal.jsx";
import Loader from "../loader/loader.jsx";
import "react-phone-input-2/lib/material.css";
import "./accountVerification.scss";

const AccountVerificationPhoneNumberFieldForm = ({
  acctPhoneNumberValue,
  setAcctPhoneNumberValue,
  acctPhoneNumberBackendError,
  setAcctPhoneNumberBackendError,
  onCancel,
  onVerifyUserAccount,
  currentContextType = "resetPasswordForm",
}) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [phoneNumberFocused, setPhoneNumberFocused] = useState(false);
  const [acctPhoneNumberErrors, setAcctPhoneNumberErrors] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // since state is set in the parent the sidEffect is placed here to trigger the modal
    if (acctPhoneNumberBackendError) {
      setShowErrorModal(true);
    }
  }, [acctPhoneNumberBackendError]);

  const handleVerifyClick = (e) => {
    e.preventDefault();
    setLoading(true);
    // clear previous errors
    setAcctPhoneNumberErrors("");
    setAcctPhoneNumberBackendError("");
    // sync validation
    const { errors } = handleAcctValidationErrors(
      acctPhoneNumberValue,
      setAcctPhoneNumberErrors
    );
    if (errors.acctPhoneNumberErrors) {
      setLoading(false);
      setShowErrorModal(true);
      return;
    }
    onVerifyUserAccount(acctPhoneNumberValue);
    setLoading(false);
  };

  const errorPhoneVerifictionMessage =
    acctPhoneNumberBackendError || acctPhoneNumberErrors || "";
  const handleCancel = (e) => {
    // hand your setLoading into the parent handler
    onCancel(e, setLoading);
  };

  return (
    <div className="form-wrapper client-form">
      {loading && <Loader className="acct-verify-loader-position" />}
      <form id="acct-verify-form">
        <div id="logo-header">
          <SkitsOlympicLogoIcon />
          <h3>Skits Olympic</h3>
        </div>
        <div className="input-group blinker-wrapper">
          <PhoneInput
            id="acctVerifyMobile"
            type="text"
            country={"us"}
            onlyCountries={["us"]}
            disableDropdown={true}
            autoComplete="off"
            placeholder={
              acctPhoneNumberErrors
                ? acctPhoneNumberErrors
                : phoneNumberFocused
                  ? ""
                  : "...Enter your mobile here"
            }
            className={acctPhoneNumberErrors ? "red-placeholder" : ""}
            inputClass={`acctVerification-control-phonelibrary-placeholder ${
              acctPhoneNumberErrors ? "field-background-color-error" : ""
            } ${phoneNumberFocused ? "focused" : ""}`}
            value={acctPhoneNumberValue}
            onChange={(value) =>
              handlePhoneInputChange(
                value,
                currentContextType,
                acctPhoneNumberErrors,
                setAcctPhoneNumberValue,
                setAcctPhoneNumberErrors
              )
            }
            onFocus={() => setPhoneNumberFocused(true)}
            onBlur={() => setPhoneNumberFocused(false)}
            error={!!acctPhoneNumberErrors.phone_number}
            disableCountryCode={true}
            inputStyle={{
              width: "100%",
              borderColor: acctPhoneNumberErrors ? "red" : "",
            }}
            helperText={
              acctPhoneNumberErrors.phone_number && "Invalid phone number"
            }
          />
          {!(phoneNumberFocused || acctPhoneNumberValue) && (
            <>
              <CellPhoneIcon
                fillColor="var(--color-white)"
                style={{
                  opacity: 0.68,
                  transition: "opacity 0.2s ease-in-out",
                  position: "absolute",
                  left: "50px",
                  top: "40%",
                  transform: "translateY(-50%)",
                }}
              />
              <span
                className="blinking-cursor-black-color acctverification-mobile-cursor"
                style={{
                  position: "absolute",
                  left: "77px",
                  top: "40%",
                  transform: "translateY(-50%)",
                }}
              >
                |
              </span>
            </>
          )}
        </div>
        {showErrorModal && (
          <ErrorMessageModal
            message={errorPhoneVerifictionMessage}
            onClose={() => {
              setShowErrorModal(false);
              setAcctPhoneNumberBackendError("");
              setAcctPhoneNumberErrors("");
            }}
          />
        )}
        <div className="cta-section">
          <InsetBlendTVButton
            id="cancel-button"
            type="button"
            btnText="X Cancel"
            style={{
              width: "fit-content",
              fontWeight: "900",
              fontFamily: "Nunito Sans",
              color: "var(--color-bloodred)",
              padding: "5px",
            }}
            onClick={handleCancel}
            />
          <InsetBlendTVButton
            id="update-button"
            type="button"
            image={<CheckMarkIcon width="20" height="20" fillColor="#b03a2e" />}
            btnText="Verify Account"
            style={{
              width: "fit-content",
              fontWeight: "900",
              fontFamily: "Nunito Sans",
              color: "var(--color-bloodred)",
              padding: "5px",
            }}
            onClick={handleVerifyClick}
          />
        </div>
      </form>
    </div>
  );
};

export default AccountVerificationPhoneNumberFieldForm;
